import React, { useEffect, useRef, useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Outlet, useParams, useNavigate } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import { useUser } from "../hook/useUser";
import { NotificationProvider } from "../component/popup/NotificationProvider";
import AppHeader from "./AppHeader";
import AppSidebar from "./AppSidebar";
import ProjectDetailsPopup from "../component/popup/ProjectDetailsPopup";
import MyProfilePopup from "../component/popup/MyProfilePopup";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0033A0",
    },
    secondary: {
      main: "#008AD8",
    },
    success: {
      main: "#00B176",
    },
    warning: {
      main: "#EFDF00",
    },
    error: {
      main: "#900B09",
    },
    background: {
      default: "#FFFFFF",
      paper: "#FFFFFF",
    },
    text: {
      dark: "#000000",
    },
  },
  typography: {
    fontSize: 11,
    fontFamily: ["Roboto", "sans-serif"].join(","),
  },
});

const HEADER_HEIGHT = isBrowser ? 76 : 40;

const ModuleLayout = () => {
  const { moduleName } = useParams();
  const navigate = useNavigate();
  const [showSideBar, setShowSideBar] = useState(isBrowser);
  const [showProjectDetails, setShowProjectDetails] = useState(false);
  const [showMyProfile, setShowMyProfile] = useState(false);
  const token = window.localStorage.getItem("token");
  const { user } = useUser();
  const headerRightButtonRef = useRef();

  useEffect(() => {
    if (!token && moduleName) {
      navigate("/");
    } else if (moduleName && user === "Token Expired") {
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("refreshToken");
      window.localStorage.removeItem("exp");
      navigate("/");
    }
  }, [moduleName, user]);

  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <Box
          sx={{
            backgroundColor: theme.palette.background.dark,
            height: "100dvh",
            width: "100vw",
            overflow: "hidden",
          }}
        >
          <CssBaseline />
          <AppHeader
            showSideBar={showSideBar}
            setShowSideBar={setShowSideBar}
            setShowProjectDetails={setShowProjectDetails}
            setShowMyProfile={setShowMyProfile}
            headerHeight={HEADER_HEIGHT}
            headerRightButtonRef={headerRightButtonRef}
          />
          {moduleName && <AppSidebar open={showSideBar} setOpen={setShowSideBar} setShowMyProfile={setShowMyProfile} headerHeight={HEADER_HEIGHT} />}
          <Box
            sx={{
              width: moduleName && isBrowser ? "calc(100vw - 205px)" : "100%",
              height: `calc(100dvh - ${HEADER_HEIGHT}px)`,
              left: moduleName && isBrowser ? "205px" : 0,
              top: `${HEADER_HEIGHT}px`,
              overflow: "auto",
              position: "relative",
              p: moduleName ? (isBrowser ? 2 : 1) : 0,
            }}
          >
            <Outlet context={{ headerRightButtonRef: headerRightButtonRef }} />
            <ProjectDetailsPopup open={showProjectDetails} onClose={() => setShowProjectDetails(false)} />
            <MyProfilePopup open={showMyProfile} onClose={() => setShowMyProfile(false)}></MyProfilePopup>
          </Box>
        </Box>
      </NotificationProvider>
    </ThemeProvider>
  );
};

export default ModuleLayout;
